export default __webpack_public_path__ + "static/media/8.e1392fee.png";